'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 头像
 */
var Webcam = React.createClass({
    render: function () {
        return (<img className="component-SimpleCom" src={assetsHelper.getComponentAsset('Webcam')}/>);
    }
});

module.exports = Webcam;



// WEBPACK FOOTER //
// ./src/views/Components/Webcam.jsx